import styled from 'styled-components';
import { HeadingExtraBoldL } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const ReportsContainer = styled.div`
  margin: 56px 56px 0 56px;
  flex-grow: 1;
`;

export const ReportsHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${({theme}: IThemeProvider) => `
      margin: 0 0 ${theme.layout.spacing.decy} 0;
   `}
`;

export const ReportsTitle = styled(HeadingExtraBoldL)``;

export const SearchBoxCont = styled.div`
  width: 579px;
  align-self: flex-end;
  margin: 9px 0 0 0;
   input {
    width: 452px;
   }
`;